import React from "react";
import type { FC, MouseEventHandler, ReactElement } from "react";
import { Box } from "@mui/system";
import { Button, Drawer, Stack, Typography } from "@mui/material";

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  Title?: ReactElement;
  items?: ({
    text: string;
    icon?: ReactElement;
    onClick: MouseEventHandler;
  } | null)[];
}

export const BottomSheet: FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  Title,
  items,
  children,
}) => {
  return (
    <Drawer open={isOpen} onClose={onClose} anchor={"bottom"}>
      <Box
        height={"3px"}
        width={"28px"}
        bgcolor={"rgba(255,255,255,0.1)"}
        alignSelf={"center"}
        mt={1.5}
        borderRadius={"3px"}
      />
      {title && (
        <Typography textAlign={"right"} m={3} fontWeight={700}>
          {title}
        </Typography>
      )}
      {Title && Title}
      <Stack overflow={"scroll"} pb={2}>
        {children}
        {items?.map((item) =>
          item === null ? null : (
            <Button
              key={item.text}
              onClick={item.onClick}
              fullWidth
              startIcon={item.icon}
              color={"secondary"}
              sx={{
                justifyContent: "space-between",
                px: 3,
                "& svg": { opacity: 0.5 },
                color: "rgba(255,255,255,0.6)",
                fontWeight: 400,
                textTransform: "none",
                borderRadius: 0,
              }}
            >
              {item.text}
            </Button>
          )
        )}
        <Box height={16} />
      </Stack>
    </Drawer>
  );
};
